import { Injectable, InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of } from 'rxjs';
import * as actions from '../actions/profile-completed.action';
import { map, catchError, tap } from 'rxjs/operators';


import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class ProfileCompletedEffects {
  private actions$ = inject(Actions);
  private platformId = inject<InjectionToken<any>>(PLATFORM_ID);

  private STORAGE_KEY = 'ROVA:PROFILE_COMPLETED_SHOWN';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {}

  hideCompletedProfile$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(actions.HideCompletedProfile),
        tap(() => {
          localStorage.setItem(this.STORAGE_KEY, JSON.stringify(false));
        })
      );
    },
    { dispatch: false }
  );

  InitCompletedProfile$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(actions.InitCompletedProfile),
      map(() => {
        const storedSettings = localStorage.getItem(this.STORAGE_KEY);

        if (storedSettings) {
          return actions.InitCompletedProfileSuccess({
            show: storedSettings === 'false' ? false : true,
          });
        }
        return actions.InitCompletedProfileSuccess({ show: true });
      }),
      catchError(error => of(actions.InitCompletedProfileFail({ error })))
    );
  });

  ClearCompletedProfile$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(actions.ClearCompletedProfile),
        tap(() => {
          localStorage.removeItem(this.STORAGE_KEY);
        })
      );
    },
    { dispatch: false }
  );
}
